import giftItemQueries from '@apis/queries/giftItemQueries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@stackflow/react';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

function useGiftItem(giftItemId: string) {
    const { data, status } = useQuery(giftItemQueries.detail(giftItemId));
    const { pop } = useFlow();
    const toast = useToast();
    useEffect(() => {
        if (status === 'error') {
            toast.error('선물하기 상품을 찾을 수 없습니다.');
            pop();
        }
    }, [pop, toast, status]);
    return data;
}

export default useGiftItem;
